import store from 'src/store';
function getActingUser() {
    return store.getters['actingUser/getActingUser'] || {};
}
function setActingUser(user) {
    store.commit('actingUser/SET_USER_OBJ', user);
}
function getActingUserControlledActions() {
    return store.getters['actingUser/getActingUserControlledActions'] || [];
}
function actingUserHasRole(x) {
    return store.getters['actingUser/actingUserHasRole'](x);
}
function actingUserHasSingleRole(x) {
    return store.getters['actingUser/actingUserHasSingleRole'](x);
}
function actingUserHasControlledAction(x) {
    return store.getters['actingUser/actingUserHasControlledAction'](x);
}
export { getActingUser, setActingUser, getActingUserControlledActions, actingUserHasRole, actingUserHasSingleRole, actingUserHasControlledAction };
